import { useOwnedParkingsImagesLive } from '@repo/domain-service';

export function useDashboardParkingData(id: string) {
  const { ownedParkings, loadingOwnedParkings: loading } = useOwnedParkingsImagesLive(
    { id },
    {
      withSpots: true,
      withBilling: true,
      withImages: true,
      withSpotsImages: true,
      withCurrentReservations: true,
      withGates: true,
    }
  );

  return {
    parking: ownedParkings[0],
    loading,
  };
}
